<!-- 首页 -->
<template>
    <div class="container flex flex-column height-all">
        <!-- 顶部搜索模块 -->
        <div class="searchContainer flex-shrink">
            <baseSearch :searchData="searchData" :isShowExport="true" @searchClick="searchBtnClick" @exportClick="exportBtnClick"/>
        </div>
        <!-- 按钮 -->
        <div class="btnWarp flex-shrink" >
            <el-button type="primary" @click="intimidateOrder(2,$event)">批量打单</el-button>
            <el-button type="success" @click="expressageClick($event)">更换快递打单</el-button>
        </div>
        <!-- 主体表格 -->
        <div class="mainTable height-all">
            <basetable tableId="workOrderListTable" tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="productList" :showopera="true" :currentPage="searchDataParam.pageNo" operaWidth="200"
                       :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true"  :showSelection="true"
                       :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                       @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
                <template v-slot:disposeCountdownMinute="scope">
                    <div class="">
                        {{formatMinutes(scope.scope.row.disposeCountdownMinute)}}
                    </div>
                </template>
                <template v-slot:opera="scope">
                    <el-button v-show="scope.scope.row.options.includes('1')"  plain type="primary" size="small" class="tableOptionBtn" @click="checkWorkOrderEdit(scope.scope,$event)">打单</el-button>
                    <el-button v-show="scope.scope.row.options.includes('2')"  plain type="danger" size="small" class="tableOptionBtn" @click="checkWorkOrderDetails(scope.scope,$event)">销毁</el-button>
                    <el-button v-show="scope.scope.row.options.includes('3')"  plain type="info" size="small" class="tableOptionBtn" >已打单</el-button>
                    <el-button v-show="scope.scope.row.options.includes('4')"  plain type="info" size="small" class="tableOptionBtn" >已销毁</el-button>
                </template>
            </basetable>
        </div>
    </div>
    <!-- 正在打印快递单 -->
    <basedialog title="" :dialogVisible="isShowPrintIngCover" :showFooter="false" :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false" center="true" dialogWidth="350">
        <template #dialogbody>
            <div class="flex justify-center flex-column align-center">
                <div class="printIngDiv">
                    <img v-if="printIngInfo.errorCount == 0" src="@/static/images/icon_printIng.png" alt="" />
                    <el-icon v-if="printIngInfo.errorCount > 0"><WarningFilled /></el-icon>
                    <span>{{printIngInfo.errorCount == 0 ? '打单中，请稍候...' : '打单异常，请重新打单'}}</span>
                </div>
                <span v-if="printIngInfo.errorCount == 0" class="printIngCount">{{printIngInfo.successCount + '/' + printOrderData.length}}</span>
                <span v-if="printIngInfo.errorCount > 0" class="printIngCount">{{'已打单' + printIngInfo.successCount + '个'}}</span>
            </div>
            <div class="dialog-footer" style="justify-content: center;align-items: flex-end;">
                <el-button size="large" @click="closePrintIng">{{printIngInfo.errorCount == 0 ? '取消打印' : '关闭'}}</el-button>
            </div>
        </template>
    </basedialog>
    <!-- 添加区域弹窗 -->
    <basedialog title="更换快递" :dialogVisible="isShowOrderDetailsCover" dialogWidth="600" @dialogConfirm="dialogConfirm" @dialogClose="dialogClose" @dialogRightTopClose="dialogClose">
        <template #dialogbody>
            <div class="addAreaCoverDiv flex justify-center flex-warp">
                <el-form ref="expressModeForm" :rules="expressModeRules" v-model="formData" class="addAreaForm">
                    <el-form-item label="快递方式: " prop="areaInfoArr" class="flex align-center">
                        <el-select v-model="formData.expressModeArr" filterable class="m-2" placeholder="请选择快递方式">
                            <el-option v-for="item in expressModeOptions" :key="item.code" :label="item.name" :value="item.code" />
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </template>
    </basedialog>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import WangEditor from '@/components/wangEditor'
import preview from '@/utils//juageProType.js'
import LodopFuncs from '@/utils//LodopFuncs.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";
import axios from 'axios'

export default {
    inject: ['$http', '$api', '$utils','$userUtils', '$uploadFileUtils'],
    name: "orderList",
    components: {
        baseSearch,
        basetable,
        basedialog,
        tableDataSelect,
        WangEditor
    },
    data() {
        return{
            searchData: [
                {
                    label: "延期拦截类型",
                    type: "select",
                    name: "queryType",
                    options: [{
                        label: "延期拦截打单列表",
                        value: '1'
                    }, {
                        label: "延期拦截销毁列表",
                        value: '2'
                    }],
                },{
                    label: "订单号",
                    type: "input",
                    name: "orderNo",
                    value: ""
                },{
                    label: "订单类型",
                    type: "select",
                    name: "orderType",
                    options: [{
                        label: "普通订单",
                        value: '1'
                    }, {
                        label: "抖音代打订单",
                        value: '2'
                    }],
                },{
                    label: "延期拦截录入来源",
                    type: "select",
                    name: "delayOrderEntrySourceType",
                    options: [{
                        label: "退件生成订单",
                        value: '1'
                    }, {
                        label: "延期生成订单",
                        value: '2'
                    }],
                },{
                    label: "处理状态",
                    type: "select",
                    name: "delayOrderDestroyedStatus",
                    options: [{
                        label: "待打单/待销毁",
                        value: '1'
                    }, {
                        label: "已打单/已销毁",
                        value: '2'
                    }],
                },{
                    label: "生产编码",
                    type: "input",
                    name: "productNum",
                    value: ""
                },{
                    label: "生产批次",
                    type: "input",
                    name: "productBatch",
                    value: ""
                },{
                    label: "生产账号",
                    type: "select",
                    name: "productUserId",
                    options: [],
                },{
                    label: "是否备注二次邮寄订单",
                    type: "select",
                    name: "isSecondMailOrderDesc",
                    options: [{
                        label: "是",
                        value: '1'
                    }, {
                        label: "否",
                        value: '0'
                    }],
                },{
                    label: "产品名称",
                    type: "input",
                    name: "productName",
                    value: ""
                }, {
                    label: "打单时间",
                    type: "datetimerange",
                    name: "printOrderTime",
                    value: [],
                }, {
                    label: "退件录入时间",
                    type: "datetimerange",
                    name: "returnAddDate",
                    value: [],
                }
            ],
            isLoading: false,
            tableTitle: [
                {
                    label: '生产编码',
                    prop: 'productNum',
                    width: 250
                }, {
                    label: '数量',
                    prop: 'productWorksCount',
                    width: 100
                }, {
                    label: '二次邮寄备注描述',
                    prop: 'secondMailOrderDesc',
                    width: 180
                }, {
                    label: '生产批次',
                    prop: 'productBatch',
                    width: 140
                }, {
                    label: '订单号',
                    prop: 'orderNo',
                    width: 150
                }, {
                    label: '订单类型',
                    prop: 'orderTypeName',
                    width: 120
                }, {
                    label: '延期拦截录入来源类型',
                    prop: 'delayOrderEntrySourceTypeName',
                    width: 180
                }, {
                    label: '订单快递',
                    prop: 'orderExpressNum',
                    width: 170
                }, {
                    label: '地址信息',
                    prop: 'userOrderAddressInfo',
                    width: 300
                }, {
                    label: '产品名称',
                    prop: 'productName',
                    width: 250
                }, {
                    label: '状态',
                    prop: 'orderStatusName',
                }, {
                    label: '打单时间',
                    prop: 'printOrderTime',
                    width: 170
                }
            ],
            productList: [],
            printOrderData: [],
            orderIds: [],
            total: 0,
            searchDataParam:{
                pageNo:1,
                pageSize:20,
            },
            customBtnList:[{
                name:'导入文件'
            }],
            productCompleteStateOptions:[{
                label: "完好",
                value: '1'
            }, {
                label: "破损",
                value: '2'
            }],
            isShowPrintIngCover: false, //是否显示正在打单弹框,
            startPrint: false, //开始打印 true：循环打印，false：暂停打单
            printIngInfo: {
                successCount: 0, //正在打单中成功的数量
                errorCount: 0, //正在打单中失败数量
            },
            currentChooseOrderIds: [],
            isShowOrderDetailsCover: false, //是否显示订单详情遮罩层
            orderDetailsInfo: {}, //订单详情
            expressModeRules: {
                "expressModeArr": [{
                    required: true,
                    message: "请选择快递方式",
                    trigger: "change"
                }],
            },
            formData: {
                expressModeArr: "",
            },
            expressModeOptions: [], //快递方式options
        }
    },
    mounted() {
        this.getProductUserOptions();
        this.getSupportExpressOptions();
        this.getWorkOrderList();
        //创建WebSocket并持续监听打单
        this.createWebSocket();
    },

    methods:{
        /**
         * 获取快递方式筛选项
         */
        getSupportExpressOptions() {
            let that = this;
            that.$http.post(that.$api.getSupportExpressOptionsApi).then(res => {
                if (res.code == 200) {
                    that.expressModeOptions = res.data;
                }
            })
        },
        /**
         * 获取生产商账号筛选项
         */
        getProductUserOptions() {
            let that = this;
            that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
                if(res.code == 200) {
                    that.searchData[6].options = [];
                    res.data.forEach((item)=>{
                        that.searchData[6].options.push({'label':item.name,'value':item.code})
                    })
                }
            })
        },
        /**
         * 获取工单列表数据
         */
        getWorkOrderList() {
            let that = this;
            that.isLoading = true;
            that.$http.post(that.$api.queryDeliveryDestroyedDelayOrderPageApi, that.searchDataParam).then(res => {
                that.isLoading = false;
                if(res.code == 200) {
                    if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
                    that.productList = res.data.list;
                }
            })
        },
        /**
         * 搜索按钮
         */
        searchBtnClick(option){
            let that = this;
            this.searchDataParam = Object.assign(this.searchDataParam,option);
            this.searchDataParam.pageNo = 1;
            this.searchDataParam.printOrderTimeStart = '' ;
            this.searchDataParam.printOrderTimeEnd = '';
            this.searchDataParam.returnAddDateStart = '' ;
            this.searchDataParam.returnAddDateEnd = '';
            if(!that.$utils.isEmpty(this.searchDataParam.printOrderTime)){
                this.searchDataParam.printOrderTimeStart = this.searchDataParam.printOrderTime[0]
                this.searchDataParam.printOrderTimeEnd = this.searchDataParam.printOrderTime[1]
            }
            if(!that.$utils.isEmpty(this.searchDataParam.returnAddDate)){
                this.searchDataParam.returnAddDateStart = this.searchDataParam.returnAddDate[0]
                this.searchDataParam.returnAddDateEnd = this.searchDataParam.returnAddDate[1]
            }
            this.getWorkOrderList()

        },
        /**
         * 设置页码
         */
        currentChange(val){
            this.searchDataParam.pageNo = val;
            this.getWorkOrderList()
        },
        /**
         * 设置页码
         */
        sizeChange(val){
            this.searchDataParam.pageSize = val;
            this.getWorkOrderList()
        },
        /**
         * 打单
         */
        checkWorkOrderEdit(scope,evt) {
            let target = evt.target;
            if(target.nodeName == "SPAN"){
                target = evt.target.parentNode;
            }
            target.blur();
            let that = this;
            let orderIds = [];
            orderIds.push(scope.row.orderId)

            that.$http.postRaw(that.$api.printOrderApi, {
                "orderIds": orderIds.toString(),
                "queryType": "noPrint",
            }).then(res => {
                that.$loading().close();
                if (res.code == 200) {
                    let resultData = res.data;
                    that.printOrderData = resultData;

                    if (that.printOrderData != null && that.printOrderData.length > 0) {
                        that.printIngInfo.successCount = 0;
                        that.printIngInfo.errorCount = 0;
                        that.startPrint = true;
                        // that.isShowPrintIngCover = true;
                        if(that.printOrderData[that.printIngInfo.successCount].type == 2){
                            //执行打单操作
                            that.generateUUid(that.printOrderData[that.printIngInfo.successCount]);
                        }else{
                            //创建新版打单
                            that.newDoPrint(that.printOrderData[that.printIngInfo.successCount])
                        }

                    } else {
                        that.$message.error("未获取到打单信息");
                    }

                }else{
                    that.$loading().close();
                }
            })
        },

        /**
         * 不可延期
         */
        checkWorkOrderDetails(scope,evt) {
            let target = evt.target;
            if(target.nodeName == "SPAN"){
                target = evt.target.parentNode;
            }
            target.blur();
            let that = this;
            this.$confirm('是否确认销毁？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                center:true
            }).then(() => {
                that.isLoading = true;
                that.$http.post(that.$api.deliveryOrDestroyedDelayOrderApi, {
                    recordId: scope.row.recordId,
                    state: 2,
                }).then(res => {
                    that.isLoading = false;
                    if(res.code == 200) {
                        this.$message.success("操作成功");
                        this.getWorkOrderList()
                    }
                })
            }).catch(() => {
                this.$message.info("操作取消");
            });
        },
        /**
         * 分钟转换处理
         */
        formatMinutes(totalMinutes){
            // 计算小时数（整数部分）
            const hours = Math.floor(totalMinutes / 60);
            // 计算剩余的分钟数
            const minutes = totalMinutes % 60;

            // 构建格式化字符串
            let result = '';
            if (hours > 0) result += `${hours}小时`;
            if (minutes > 0 || hours === 0) result += `${minutes}分钟`;

            return result;
        },

        /**
         * 创建WebSocket
         */
        createWebSocket() {
            let that = this;
            that.socket = new WebSocket('ws://127.0.0.1:13888');
            // console.log("that.socket:::", that.socket);
            // 监听消息
            that.socket.onmessage = function(event) {
                // console.log('Client received a message', event);
                console.log('监听消息打印', event)
                let dataStr = event.data;
                if (dataStr != null && dataStr != '') {
                    let data = JSON.parse(dataStr);
                    console.log('监听消息打印格式化后', data)
                    if (data.cmd == 'print') { //打印
                        if (data.status == 'success') {
                            console.log('等待打印...')
                        }
                    }
                    if (data.cmd == 'notifyPrintResult') { //打印回调
                        // 确认打单成功
                        if (data.status == 'success' && data.taskStatus == 'printed') {
                            that.confirmPrintOrder(data.printStatus[0].trackNo)
                            that.$utils.saveServiceLog(1,'打印完成trackNo:'+ data.printStatus[0].trackNo)
                            console.log('打印完成')
                        } else {
                            this.$loading().close();
                            that.printIngInfo.errorCount += 1;
                            that.$message.error("任务id：" + data.taskID + ",失败原因【" + data.printStatus[0].msg + "】");
                            that.$utils.saveServiceLog(2,'失败'+ data.printStatus[0].trackNo+ ":" + data.toString())
                            console.log('失败原因', data)
                        }
                    }
                }
            };
            // 监听Socket的关闭
            that.socket.onclose = function(event) {
                console.log('Client notified socket has closed', event);
            };
        },
        /**
         * 批量打印电子面单打印成功
         */
        confirmPrintOrder(trackNo,retryCount = 0) {
            let confirmOrderInfoJson = '';
            let orderInfoJsonList = '';
            // 定义最大重试次数
            const maxRetryTimes = 3;
            for (let i = 0; i < this.printOrderData.length; i++) {
                if (this.printOrderData[i].trackNo == trackNo) {
                    confirmOrderInfoJson = this.printOrderData[i].confirmOrderInfoJson
                    orderInfoJsonList = this.printOrderData[i].orderInfoJsonList

                    this.$http.postRaw(this.$api.confirmPrintOrderApi, {
                        confirmOrderInfoJson: confirmOrderInfoJson,
                        orderInfoJsonList: orderInfoJsonList
                    }).then(res => {
                        if (res.code == 200) {
                            this.printIngInfo.successCount += 1;
                            if(this.printIngInfo.successCount >= this.printOrderData.length){
                                this.$loading().close();
                                setTimeout(()=>{
                                    this.closePrintIng();
                                },1000)
                                this.$message.success("打印完成");

                            }else{
                                if (this.startPrint) {
                                    if(this.printOrderData[this.printIngInfo.successCount].type == 2){
                                        //执行打单操作
                                        this.generateUUid(this.printOrderData[this.printIngInfo.successCount]);
                                    }else{
                                        //创建新版打单
                                        this.newDoPrint(this.printOrderData[this.printIngInfo.successCount]);
                                    }
                                } else {
                                    // 更新列表
                                    this.getWorkOrderList();
                                }
                            }
                        }else{
                            if (retryCount < maxRetryTimes) {
                                setTimeout(() => {
                                    this.confirmPrintOrder(trackNo, retryCount + 1);
                                }, 1000); // 补充2秒间隔，原代码此处缺失时间参数
                            } else {
                                this.$loading().close();
                            }

                        }
                    }).catch(()=>{
                        if (retryCount < maxRetryTimes) {
                            setTimeout(() => {
                                this.confirmPrintOrder(trackNo, retryCount + 1);
                            }, 1000); // 补充2秒间隔，原代码此处缺失时间参数
                        } else {
                            this.$loading().close();
                        }
                    })
                    break;
                }
            }

        },
        /**
         * 执行打单操作
         * @param {Object} resultData
         */
        printDoOrder(resultData) {
            let that = this;
            if (resultData != null && resultData.length > 0) {
                resultData.forEach((item, index) => {

                    if(item.type == 2){
                        //执行打单操作
                        that.generateUUid(item);
                    }else{
                        //创建新版打单
                        that.newDoPrint(item)
                    }
                })
            } else {
                that.$loading().close();
                that.$message.error("未获取到打单信息");
            }
        },
        /**
         * 新版打印
         */
        newDoPrint(item) {
            let that = this;
            that.LODOP = LodopFuncs.getLodop();
            that.LODOP.PRINT_INIT(`Page_${item.trackNo}`);
            that.LODOP.SET_PRINTER_INDEX(item.printer);
            that.LODOP.ADD_PRINT_IMAGE(0, 0, '76mm', '130mm', `<img src="${item.printerData}">`);
            that.LODOP.SET_PRINT_STYLEA(0, "Stretch", 2);
            that.LODOP.On_Return_Remain = true;
            that.$utils.saveServiceLog(1,'新版开始打单trackNo:' + item.trackNo)
            // 执行打印并获取任务ID
            const taskId = that.LODOP.PRINT();
            console.log("创建打印任务的taskId", taskId);

            // 阻塞等待当前任务完成
            that.monitorTaskStatus(taskId,item);
        },
        /**
         * 新版打印回调
         */
        monitorTaskStatus(id,item) {
            let that = this;
            let retryCount = 0;
            let timerId = '';
            const maxRetries = 20;
            let isCompleted = false; // 标记任务是否完成

            // 轮询检查函数
            const checkStatus = () => {
                retryCount++;
                if (retryCount > maxRetries) {
                    console.error(`任务 ${id} 超时`);
                    that.$utils.saveServiceLog(1,'新版打单失败（超时）:' + item.trackNo)
                    that.printIngInfo.errorCount += 1;
                    clearTimeout(timerId);
                    return;
                }
                if (isCompleted){
                    clearTimeout(timerId);
                    return; // 若已完成则跳过
                }
            };

            // 定义 On_Return 回调（全局只绑定一次）
            that.LODOP.On_Return = function(TaskID, Value) {
                if (that.$utils.isEmpty(Value)) {
                    console.log(`任务 ${id} 完成`);
                    that.$utils.saveServiceLog(1,'新版打单成功:' + item.trackNo)
                    that.confirmPrintOrder(item.trackNo)
                    isCompleted = true;
                } else {
                    console.log(`任务 ${id} 未完成，重试中...`);
                    clearTimeout(timerId);
                    timerId =  setTimeout(checkStatus, 200);
                }
            };

            // 主动查询任务状态（触发 On_Return 回调）
            that.existStatus = that.LODOP.GET_VALUE("PRINT_STATUS_EXIST", id);
            console.log(`启动检测`);
        },
        /**
         * 发送打印数据
         * @param {Object} order_no
         * @param {Object} track_no
         * @param {Object} params
         * @param {Object} sign
         * @param {Object} print_data
         * @param {Object} product_num
         * @param {Object} product_name
         * @param {Object} product_count
         * @param {Object} baseTemplateUrl
         * @param {Object} templateUrl
         * @param {Object} printer
         */
        doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer, remark) {
            let that = this;
            let request = {
                cmd: "print",
                requetID: that.getUUID(8,16),
                version: "1.0",
                task: {
                    "taskID": that.getUUID(8,16),
                    "printer": printer,
                    "documents": [{
                        "documentID": track_no,//运单号，可选
                        "contents": [{
                            "params": params,
                            "signature": sign,
                            "encryptedData": print_data,
                            "templateURL": baseTemplateUrl,
                            "addData": {
                                "senderInfo": {
                                    "address": {
                                        "cityName": "石家庄市",
                                        "countryCode": "CHN",
                                        "detailAddress": "ICC环球智汇中心写字楼C座809",
                                        "districtName": "裕华区",
                                        "provinceName": "河北省"
                                    },
                                    "contact": {
                                        "mobile": "0311-88898111",
                                        "name": "美印兔兔"
                                    }
                                }
                            },
                            "config": {
                                "printlogo": true
                            }
                        }, {
                            //自定义模板，如果没有，就不要传此对象
                            "data": {
                                "productInfo": product_name,
                                "shopName": order_no,
                                "orderId": product_num,
                                "remark": remark,
                                "productCount": product_count + '件'
                            },
                            "templateURL": templateUrl
                        }]
                    }]
                }
            };
            that.$loading().close();
            that.socket.send(JSON.stringify(request));
        },
        /**
         * 获取UUID
         */
        getUUID(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [], i;
            radix = radix || chars.length;
            if (len) {
                for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
            } else {
                var r;
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }
            return uuid.join('');
        },
        /**
         * 正在打单弹框点击取消打单
         */
        closePrintIng() {
            this.startPrint = false;
            this.isShowPrintIngCover = false;
            console.log('点击暂停打印了')
            // 更新列表
            this.getWorkOrderList()
        },
        /**
         * 获取UUID
         */
        generateUUid(item) {
            let that = this;
            let order_no = item.orderNo;
            let track_no = item.trackNo;
            let params = item.param;
            let sign = item.sign;
            let printer = item.printer;
            let print_data = item.printerData;
            let product_num = item.productNum;
            let product_name = item.productName;
            let product_count = item.productCount;
            let logistics_code = item.logisticsCode;
            let baseTemplateUrl = item.baseTemplateUrl;
            let templateUrl = item.templateUrl;
            let remark = item.remark;
            that.$utils.saveServiceLog(1,'开始打单trackNo:' + item.trackNo)
            that.doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer, remark);

        },
        /**
         * 导出
         */
        exportBtnClick(option){
            let that = this;
            this.$confirm('是否只导出当前页？', '提示', {
                confirmButtonText: '是',
                cancelButtonText: '导出全部',
                distinguishCancelAndClose: true,
                type: 'warning',
                center:true
            }).then(() => {
                console.log('导出当前页')
                that.exportSimplePageData();
            }).catch(action => {
                console.log(action)
                if (action === 'cancel') {
                    console.log('导出全部')
                    that.exportAllData();
                }

            });

        },
        /**
         * 导出当前页
         */
        exportSimplePageData() {
            let that = this;
            //导出
            that.exportDyOrder(1);
        },
        /**
         * 导出全部
         */
        exportAllData() {
            let that = this;
            that.exportDyOrder(0);
        },
        /**
         * 导出数据
         * @param {Object} type  1：导出当前页     0：导出全部
         */
        exportDyOrder(type) {
            let that = this;
            let param = Object.assign(this.searchDataParam,{"expFlag": type});
            that.$loading();
            that.$http.post(that.$api.exportAfterSaleConfirmDelayOrderApi, param).then(res => {
                that.$loading().close();
                if(res.code == 200) {
                    that.$message.success("导出成功，请到我的文件查看");
                }
            })
        },
        /**
         * 复选框
         */
        selectionChange(val) {
            this.currentChooseOrderIds = val;
            console.log(val)
        },
        /**
         * 打单按钮点击事件
         * type: 1:全部打印  2:批量打印
         */
        intimidateOrder(type,evt) {
            let that = this;
            let orderIds = [];
            if(type == 2){
                let target = evt.target;
                if (target.nodeName == "SPAN") {
                    target = evt.target.parentNode;
                }
                target.blur();
                if(that.currentChooseOrderIds.length == 0){
                    that.$message.warning("请选择要打印的订单");
                    return
                }
                that.currentChooseOrderIds.forEach((item) => {
                    orderIds.push(item.orderId)
                })
            }
            if (that.currentChooseOrderIds.length > 0 || !this.$utils.isEmpty(that.searchDataParam.orderNo) || !this.$utils.isEmpty(that.searchDataParam.orderType) || !this.$utils.isEmpty(that.searchDataParam.productNum) || !this.$utils.isEmpty(that.searchDataParam.productBatch) || !this.$utils.isEmpty(that.searchDataParam.productUserId) || !this.$utils.isEmpty(that.searchDataParam.productName) || !this.$utils.isEmpty(that.searchDataParam.workOrderState)) {
                console.log(that.formData)

                that.$loading();
                that.$http.postRaw(that.$api.printOrderApi, {
                    "orderIds": orderIds.toString(),
                    "queryType": "noPrint",
                }).then(res => {
                    that.$loading().close();
                    if (res.code == 200) {
                        let resultData = res.data;
                        that.printOrderData = res.data;
                        that.printIngInfo.successCount = 0;
                        that.printIngInfo.errorCount = 0;
                        if (that.printOrderData != null && that.printOrderData.length > 0) {
                            that.startPrint = true;
                            that.isShowPrintIngCover = true;
                            if(that.printOrderData[that.printIngInfo.successCount].type == 2){
                                //执行打单操作
                                that.generateUUid(that.printOrderData[that.printIngInfo.successCount]);
                            }else{
                                //创建新版打单
                                that.newDoPrint(that.printOrderData[that.printIngInfo.successCount])
                            }

                        } else {
                            that.$message.error("未获取到打单信息");
                        }
                    }
                })
            } else {
                that.$message.warning("请选择要打印的订单");
                return
            }
        },
        /**
         * 更换快递遮罩
         */
        expressageClick(evt) {
            let target = evt.target;
            if (target.nodeName == "SPAN") {
                target = evt.target.parentNode;
            }
            target.blur();
            let that = this;
            if (that.currentChooseOrderIds.length == 0) {
                that.$message.warning("请选择要更换的订单");
                return
            }

            that.formData.expressModeArr = "";
            this.isShowOrderDetailsCover = true;
        },
        /**
         * 关闭地址选择
         */
        dialogClose() {
            this.isShowOrderDetailsCover = false;
        },
        /**
         * 更换快递
         */
        dialogConfirm() {
            let that = this;
            if (that.$utils.isEmpty(that.formData.expressModeArr)) {
                that.$message.warning("请选择快递方式");
                return
            }
            let orderIds = [];
            console.log(that.formData)

            that.currentChooseOrderIds.forEach((item) => {
                orderIds.push(item.orderId)
            })
            this.$loading();
            that.$http.postRaw(that.$api.batchChangePrintOrderApi, {
                "orderIds": orderIds.toString(),
                "usePostal": that.formData.expressModeArr.toString(),
            }).then(res => {
                that.confirmLoading = false;
                that.$loading().close();
                if (res.code) {
                    that.isShowOrderDetailsCover = false;

                    that.printOrderData = res.data;
                    that.printIngInfo.successCount = 0;
                    that.printIngInfo.errorCount = 0;

                    if (that.printOrderData != null && that.printOrderData.length > 0) {
                        that.startPrint = true;
                        that.isShowPrintIngCover = true;
                        if(that.printOrderData[that.printIngInfo.successCount].type == 2){
                            //执行打单操作
                            that.generateUUid(that.printOrderData[that.printIngInfo.successCount]);
                        }else{
                            //创建新版打单
                            this.newDoPrint(this.printOrderData[this.printIngInfo.successCount])
                        }

                    } else {
                        that.$loading().close();
                        that.$message.error("未获取到打单信息");
                    }
                }
            }).catch(err => {
                that.confirmLoading = false;
            })
        },
    },
}
</script>
<style scoped>
.mainCont .container{
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 12px;
    box-sizing: border-box;
}
.workOrderReplyImg{
    width: 100px;
    height: 100px;
    background-color: #efefef;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.workInfoCoverDiv{
    width: 400px;
    height: 100%;
    z-index: 3000;
    background: #fff;
    padding: 24px;
    box-sizing: border-box;
}
.workInfoCoverDiv .workOrderDetailsInfoItem span{
    width: 85px;
}
.workInfoCoverDiv .workOrderDetailsInfoItem p{
    width: calc(100% - 85px);
}
.workInfoCoverDiv .workOrderDetailsInfoItem{
    width: 100%;
    margin-top: 0;
    margin-bottom: 10px;
}

.workTotalPages{
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin: 20px 0;
}
.workPreviewListDiv{
    overflow: auto;
    /*padding: 0 25px;*/
    max-height: 620px;
}
.workPreviewItemDiv{
    width: 220px;
    height: 300px;
    border: 1px solid #efefef;
    overflow: hidden;
    margin-right: 15px;
    float: left;
    margin-bottom: 15px;
    cursor: pointer;
    background-color: rgba(0,0,0,0.1);
}
.workPreviewItemDiv:nth-child(4n) {
    margin-right: 0;
}
.workPreviewImg img{
    height: 100%;
    width: auto;
}
.currentWrokPreviewPage{
    height: 32px;
    line-height: 32px;
    background: rgba(0,0,0,0.5);
    font-size: 12px;
    text-align: center;
    color: #fff;
}


.communicateListDiv{
    width: 70%;
    margin-top: 12px;
}
.communicateItemDiv{
    overflow: auto;
    margin-bottom: 20px;
}
.communicateUserHeaderDiv{
    width: 60px !important;
    height: 60px !important;
}
.communicateItemRightDiv .communicateUserHeaderDiv{
    float: right;
}
.communicateItemRightDiv .submitUserInfoDiv p{
    text-align: right;
}
.historyWorkOrderResult{
    position: absolute;
    right: 35px;
    color: #009688;
}
.redColor{
    color: #E02020;
}
.problemDescPicsListDiv{
    width: calc(100% - 160px);
    float: left;
    overflow: auto;
}
.problemDescPicDiv{
    width: 100px;
    height: 100px;
    overflow: hidden;
    background-color: #efefef;
    margin-right: 12px;
    float: left;
}
.problemDescPicDiv img{
    width: 100%;
}
.sendToMY{
    margin: 50px 0 20px;
    text-align: center;
}
/* 工单详情遮罩层 */
.workOrderDetailsCover, .previewWorkCover{
    background: rgba(0,0,0,0.5);
}
.workOrderDetailsDiv, .previewWorkDiv{
    width: 100%;
    background: #fff;
    padding: 10px;
    border-radius: 5px;
}
.coverTitle{
    text-align: center;
    font-size: 16px;
    color: #000;
    line-height: 40px;
}
.closeCoverDiv{
    width: 30px;
    height: 30px;
    top: 15px;
    right: 15px;
    cursor: pointer;
}
.closeCoverDiv img{
    width: 20px;
}
.detailsInfoDiv{
    /*max-height: 800px;*/
    /*overflow-y: scroll;*/
    /*padding: 0 20px 30px;*/
    box-sizing: border-box;
}
.workOrderDetailsInfo, .infoSearchDiv{
    overflow: auto;
    font-size: 13px;
    margin-bottom: 15px;
}
.workOrderDetailsInfoItem{
    width: 50%;
    margin-top: 12px;
    overflow: auto;
    padding-right: 16px;
    box-sizing: border-box;
    float: left;
}
.workOrderDetailsInfoItem span{
    width: 110px;
    display: inline-block;
    float: left;
    color: #666;
    line-height: 22px;
    font-size: 14px;
}
.workOrderDetailsInfoItem p{
    width: calc(100% - 110px);
    font-size: 13px;
    float: left;
    word-break: break-all;
    line-height: 22px;
}
.workPreviewDiv{
    width: 15%;
    height: auto;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
}
.workPreviewDiv img{
    width: 100%;
}
.workPreviewDiv .previewWorkBtn{
    /* margin-left: 16px; */
    margin-top: 10px;
}
.workPreviewInit{
    width: 72%;
    height: auto;
}
.workOrderInfoDiv{
    overflow: auto;
    margin-bottom: 20px;
}
.workOrderSubmitUserHeaderDiv{
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #efefef;
    float: left;
}
.workOrderSubmitUserHeaderDiv img{
    width: 100%;
}
.submitUserInfoWarpDiv{
    overflow: auto;
}
.submitUserInfoDiv{
    float: left;
    width: calc(100% - 92px);
    height: 100%;
    margin-left: 12px;
}
.userName, .submitTime, .telphone{
    font-size: 12px !important;
    columns: #333;
    line-height: 25px;
}
.telphone span{
    font-size: 12px !important;
}
.telphone img{
    max-width: 30% !important;
}

.printIngDiv {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: #333333;
}

.printIngDiv img {
    width: 18px;
    margin-right: 10px;
}

.printIngCount {
    font-size: 16px;
    color: #666666;
    margin-top: 20px;
}

.printIngDiv .el-icon{
    margin-right: 10px;

    color: #ff0000;
}
</style>
<style>
.el-divider__text{
    font-weight: bold;
}
.el-collapse-item__header{
    position: relative;
}
.workOrderReplyImg .el-image__inner{
    width: 100% !important;
    height: auto !important;
}
.el-table .highlight{
    background-color: rgba(255, 157, 77, 0.3);
}
.el-image-viewer__wrapper{
    z-index: 99999!important;
}

.telphone span{
    font-size: 12px !important;
}
.telphone img{
    max-width: 51% !important;
}
.productCompleteTitle{
    margin-bottom: 12px;
}
</style>